import React, { useEffect, useState } from 'react';
import './Home.css'
import LeagueCard from '../LeagueCard/LeagueCard'

const Home = () => {
    const [leagues,setLeagues]=useState([]);
    useEffect(()=>{
        const url=`https://www.thesportsdb.com/api/v1/json/1/all_leagues.php`;
        fetch(url)
        .then(res=>res.json())
        .then(data=>{
            const results=data.leagues;
            let arr=[];
            for(let i=0;i<10;i++){
                 arr=[...arr,results[i]]; 
            }
            setLeagues(arr);
        })
    },[])

   
    return (
        <div className="bg-dark">
            <div className="cover-img-container d-flex align-items-center justify-content-center text-white">
                <h1 className="bg-dark">SPORTS MEDIA</h1>
            </div>
            <div className="bg-dark"> 
                {
                    leagues.map(league=><LeagueCard league={league}></LeagueCard>)
                }
            </div>
            
        </div>
    );
};

export default Home;